import * as yup from 'yup';

export const adminSchema = yup.object().shape({
    name: yup
        .string()
        .required('กรุณากรอกชื่อ-นามสกุล')
        .max(200, 'ไม่เกิน 200 ตัวอักษร'),
    one_mail: yup.string().nullable().email('อีเมลไม่ถูกต้อง'),
});
